export const environment = {
  production: true,
  microsoftGraphUrl: 'https://graph.microsoft.com/v1.0',
  siteUrl: 'https://planmy.day/',
};
